import { Component, inject, signal } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { CaseIncident, TheftReportAttachmentType } from 'src/app/types';
import { UiModule } from '../../../../components/ui.module';
import { LossPreventionService } from 'src/app/service/loss-prevention.service';
import { resolveKioskPhotoUrl } from 'src/app/secure/components/suspect-image/suspect-image.component';

@Component({
  selector: 'app-pan-cell-case-tracking-photo',
  imports: [UiModule],
  templateUrl: './cell-case-tracking-photo.component.html',
  styleUrl: './cell-case-tracking-photo.component.scss',
})
export class CellCaseTrackingPhotoComponent implements ICellRendererAngularComp {
  private lpService = inject(LossPreventionService);
  public params!: ICellRendererParams<CaseIncident>;
  public photoLink = signal<string>('');
  public isLoading = signal<boolean>(true);

  agInit(params: ICellRendererParams<CaseIncident>) {
    this.params = params;
    this.resolvePhotoUrl().then((url) => this.photoLink.set(url));
  }

  refresh(params: ICellRendererParams<CaseIncident>) {
    this.params = params;
    this.resolvePhotoUrl().then((url) => this.photoLink.set(url));
    return true;
  }

  async resolvePhotoUrl() {
    if (this.params.data.use_kiosk_photo && this.params.data.image_id) {
      const url = await resolveKioskPhotoUrl(this.params.data.image_id);
      this.isLoading.set(false);
      return url;
    }
    this.isLoading.set(false);
    return this.params.data.attachments?.find((a) => a.type === TheftReportAttachmentType.InstancePhoto)?.content ?? '';
  }
}
